<template>
  <table class="d-table d-table__tasks">
    <thead>
    <tr>
      <th class="th-sorter"
          :class="{'th-sorter--active': sortKey === 'name'}"
          @click="setSortKey('name')">
        {{ getI18n(title) }}
        <span class="icon-menu-open"></span>
      </th>
      <th class="th-sorter"
          :class="{'th-sorter--active': sortKey === 'calendar'}"
          @click="setSortKey('calendar')">
        {{ $t('vue2.task_overview.belongs_to') }}
        <span class="icon-menu-open"></span>
      </th>
      <th class="th-sorter is-number"
          v-if="isShowScheduled"
          @click="setSortKey('actual')"
          :class="{'th-sorter--active': sortKey === 'actual'}">
        {{ $t('vue2.assign_users_hours.scheduled') }}
        <span class="icon-menu-open"></span>
      </th>
    </tr>
    </thead>
    <tbody>
    <!-- Grouped tasks -->
    <template v-for="taskGroup in tasksGrouped">
      <tr class="d-table__second-header">
        <th colspan="2">
          {{ getI18n(taskGroup.masterType ) }}
        </th>
        <th class="is-number">
          <template v-if="isShowScheduled">{{ toFixedIfNecessary(taskGroup.sum, 2) }}</template>
        </th>
      </tr>
      <!-- Task rows -->
      <tr v-for="task in taskGroup.events" :key="task.id" :data-task-id="task.id">
        <td>
          <div class="task-with-edit">
            <div class="subjects_subject"
                 v-if="task.can_schedule === 't'"
                 :style="{'background': task.color}">
              {{ task.name }}
            </div>
            <div v-else class="subjects_subject subjects_subject--not-subject">{{ task.name }}</div>
          </div>
        </td>
        <td class="td-calendars">
          {{ task.calendar }}
        </td>
        <td class="is-number" v-if="isShowScheduled">{{ getTaskActual(task) }}</td>
      </tr>
    </template>
    </tbody>
    <tfoot>
    <tr>
      <td></td>
      <td></td>
      <td class="is-number" v-if="isShowScheduled" :class="{'th-sorter--active': sortKey === 'actual'}">
        {{ sumOfActual }}
      </td>
    </tr>
    </tfoot>
  </table>
</template>

<script>
import DDropdown from '../common/DDropdown'

export default {
  components: {DDropdown},
  props: {
    userCalendarId: {
      default: 13
    },
    userId: {
      default: 7
    },
    title: {
      type: String,
      default: 'Øvrige opgaver'
    },
    tasks: {
      default: () => []
    },
    assignedHours: {
      default: '0.0'
    },
    isShowScheduled: {
      default: false,
      type: Boolean
    }
  },
  data () {
    return {
      sortKey: 'name',
      sortOrder: 1
    }
  },
  computed: {
    localPoolTitle () {
      const title = this.$store.getters.localPoolTitle
      return title || this.$t('vue2.task_overview.pool')
    },
    isOnlyShowScheduled () {
      return this.title === 'absence' || this.title === 'substitute_hours'
    },
    sortedTasks () {
      let sortKey = this.sortKey
      let order = this.sortOrder
      let data = this.tasks
      if (sortKey) {
        data = data.sort((a, b) => {
          a = a[sortKey]
          b = b[sortKey]
          if (sortKey !== 'name' && sortKey !== 'calendar') {
            if (order < 0) {
              return a - b
            } else {
              return b - a
            }
          } else {
            a = a.toLowerCase()
            b = b.toLowerCase()
            return (a === b ? 0 : a > b ? 1 : -1) * order
          }
        })
      }
      return data
    },
    tasksGrouped () {
      const types = [/* {masterType: : events: [], sum: } */]
      this.sortedTasks.forEach(event => {
        const idx = types.findIndex(masterType => masterType.masterType === event.master_type)
        if (idx < 0) {
          const obj = {masterType: event.master_type, events: [event], sum: event.actual}
          types.push(obj)
        } else {
          types[idx]['events'].push(event)
          types[idx]['sum'] += event.actual
        }
      })
      const masterTypeOrder = ['teaching', 'club', 'other', 'preparation', 'pool', 'unknown']  // Define the order for master types

// Sort types by masterTypeOrder
      types.sort((a, b) => {
        const aIndex = masterTypeOrder.indexOf(a.masterType)
        const bIndex = masterTypeOrder.indexOf(b.masterType)

        // If masterType is not found in the order, set index to a large number (e.g., 9999) so it's sorted to the end
        const aFinalIndex = aIndex === -1 ? 9999 : aIndex
        const bFinalIndex = bIndex === -1 ? 9999 : bIndex

        return aFinalIndex - bFinalIndex
      })

      return types
    },
    sumOfHours () {
      let tasksHours = [0]
      if (this.tasks.length > 0) {
        tasksHours = this.tasks.map(task => {
          return parseFloat(task.hours)
        })
      }
      let sum = tasksHours.reduce((acc, item) => acc + item)
      return this.toFixedIfNecessary(sum, 2)
    },
    sumOfActual () {
      let tasksActual = [0]
      if (this.tasks.length > 0) {
        tasksActual = this.tasks.map(task => {
          let actual = task.actual ? task.actual : 0
          return parseFloat(actual)
        })
      }
      let sum = tasksActual.reduce((acc, item) => acc + item)
      return this.toFixedIfNecessary(sum, 2)
    },
    sumOfDiff () {
      let tasksNumbers = [0]
      if (this.tasks.length > 0) {
        tasksNumbers = this.tasks.map(task => {
          return parseFloat(task.diff)
        })
      }
      let sum = tasksNumbers.reduce((acc, item) => acc + item)
      return this.toFixedIfNecessary(sum, 2)
    },
    allCalendarsInHash () {
      return this.$store.getters.allCalendarsInHash
    },
    subjectsInHash () {
      return this.$store.getters.subjectsInHash
    }
  },
  methods: {
    getI18n (title) {
      switch (title) {
        case 'teaching':
          return this.$t('vue2.task_overview.teaching')
        case 'other':
          return this.$t('vue2.task_overview.tasks')
        case 'preparation':
          return this.$t('vue2.task_overview.preparation')
        case 'absence':
          return this.$t('vue2.task_overview.absence')
        case 'club':
          return this.$t('vue2.task_overview.club')
        case 'substitute_hours':
          return this.$t('vue2.task_overview.substitute_hours')
        case 'pool':
          return this.localPoolTitle
        case 'unknown':
          return this.$t('vue2.task_overview.unknown')
        case 'with_kids':
          return 'Tid med børn'
        case 'without_kids':
          return 'Tid uden børn'
        default:
          return title
      }
    },
    setSortKey (prop) {
      this.sortKey = prop
      this.sortOrder === 1 ? this.sortOrder = -1 : this.sortOrder = 1
    },
    toFixedIfNecessary (value, dp) {
      // https://stackoverflow.com/questions/32229667/have-max-2-decimal-places/32229831
      return +parseFloat(value).toFixed(dp)
    },
    getTaskActual (task) {
      let actual = task.actual ? task.actual * 1 : 0
      return this.toFixedIfNecessary(actual, 2)
    },
    getTasksHours (task) {
      return this.toFixedIfNecessary(task.hours, 2)
    },
    calcDifference (task) {
      let actual = task.actual ? task.actual * 1 : 0
      let hours = parseFloat(task.hours)
      return this.toFixedIfNecessary(hours - actual, 2)
    },
    getSubjectHours (task) {
      let theSubject = task
      let idx = theSubject.teachers[0] ? theSubject.teachers.findIndex(teacher => teacher.user_id === this.userId) : -1
      let num = 0
      if (idx > -1) {
        num = theSubject.teachers[idx].hours
      } else {
        num = theSubject.hours
      }
      return parseFloat(num).toFixed(1)
    },
    setEditTask (task) {
      this.$emit('edit', task)
    },
    setDeleteTask (task) {
      this.$emit('delete', task)
    },
    getShowCalendarIfNotOwn (task) {
      let isInOwnCalendar = task.belongs_to_calendars ? task.belongs_to_calendars.indexOf(this.userCalendarId) > -1 : task.calendar_id === this.userCalendarId
      if (isInOwnCalendar) {
        return []
      } else {
        return task.belongs_to_calendars ? task.belongs_to_calendars.map(calId => this.allCalendarsInHash[calId]) : [this.allCalendarsInHash[task.calendar_id]]
      }
    },
    scaleIndicator (diff) {
      let color = 'rgba(62, 207, 142, 0.4)'
      let newDiff = parseFloat(diff)
      let indicatorPercentage = parseFloat(newDiff.toFixed(0))
      if (indicatorPercentage < 10 && indicatorPercentage > 0) {
        indicatorPercentage = '0' + indicatorPercentage
      }
      if (indicatorPercentage > -10 && indicatorPercentage < 0) {
        indicatorPercentage = '0' + (indicatorPercentage * -1)
      }
      if (indicatorPercentage < -9 && indicatorPercentage < 0) {
        indicatorPercentage = indicatorPercentage * -1
      }
      if (newDiff === 0) {
        color = 'transparent'
      }
      if (newDiff < 0) {
        color = 'rgba(250, 86, 90, 0.' + indicatorPercentage + ')'
      }
      if (newDiff < -99) {
        color = 'rgba(250, 86, 90, 1)'
      }
      if (newDiff > 0) {
        color = 'rgba(62, 207, 142, 0.' + indicatorPercentage + ')'
      }
      if (newDiff > 99) {
        color = 'rgba(62, 207, 142, 1)'
      }
      return {'backgroundColor': color}
    }
  },
  beforeMount () {
    this.tasks.forEach((task, i) => this.$set(this.tasks[i], 'diff', this.calcDifference(task)))
  }
}
</script>

<style scoped>
@import "../../assets/css/variables.css";

.d-table__tasks {
  border-collapse: collapse;
  background-color: #ffffff;
  width: 100%;
}

.d-table__tasks {
  font-size: 10px;
}

.d-table__tasks thead th:first-child,
.d-table__tasks tbody td:first-child {
  max-width: 300px;
  width: 20%
}

.d-table__tasks thead th:nth-child(2),
.d-table__tasks tbody td:nth-child(2),
.d-table__tasks.d-table > tfoot td:nth-child(2) {
  display: none;
}

@media only screen and (min-width: 500px) {
  .d-table__tasks {
    font-size: 1rem;
  }
}
.d-table__tasks thead th:nth-child(2),
.d-table__tasks tbody td:nth-child(2),
.d-table__tasks.d-table > tfoot td:nth-child(2) {
  display: table-cell;
}

.d-table > thead, .d-table > tfoot {
  border: 1px solid #e2e8f0;
  text-transform: uppercase;
  font-weight: bold;
  text-align: left;
  background: #f6f9fc;
}

.d-table > tfoot tr:last-child {
  font-size: 13px;
}

.d-table > thead > tr > th,
.d-table > tfoot > tr > td {
  padding: 5px;
}

.d-table > thead > tr:first-child, .d-table > tfoot > tr:first-child {
  color: #8898aa;
}

.d-table tr th, .d-table > tfoot tr td {
  padding: 4px 8px;
}

.d-table > tfoot tr td {
  color: #8898aa;
}

.d-table > tfoot tr td.th-sorter--active {
  color: var(--dark-blue);
}

.d-table tbody tr:nth-child(even) {
  background-color: #f9fafb;
}

.d-table tr th h4 {
  color: #3e4450;
}

.d-table tr td {
  padding: 0 8px;
}

.d-table tbody tr:hover {
  background: #eee !important;
}

.subjects_subject {
  position: relative;
  padding: 4px 6px;
  height: 30px;
  color: #ffffff !important;
  border-radius: 4px;
  word-break: break-all;
  background: #2c81ba;
  overflow: hidden;
  box-shadow: 1px 1px 5px rgba(0, 0, 0, .3);
  text-align: left;
  margin: 5px 5px 5px 0px;
  min-width: auto;
  font-weight: bold;
  transition: transform 0.25s;
  animation: fadeIn;
}

.subjects_subject.subjects_subject--not-subject {
  box-shadow: none;
  background-color: transparent;
  color: var(--dark-blue) !important;
  border: 1px solid transparent;
}

.subjects_subject.subjects_subject--not-subject:hover {
  /* border: 1px solid var(--border-color); */
  border: none;
}

.is-number {
  text-align: right;
}

tbody tr:first-child td .subjects_subject {
  margin-top: 5px;
}

tbody tr:last-child td .subjects_subject {
  margin-bottom: 10px;
}

.italic {
  font-style: italic;
}

.td-calendars {
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 80px;
  overflow: hidden;
  font-size: 11px;
}

.d-table tbody td:nth-child(2) {
  width: 50%;
}

.d-table tbody td:nth-child(3),
.d-table tbody td:nth-child(4),
.d-table tbody td:nth-child(5) {
  width: 10%;
}

.th-sorter {
  align-items: center;
  cursor: pointer;
  user-select: none;
  transition: transform 0.25s;
}

.th-sorter.th-sorter--active {
  color: var(--dark-blue);
}

.th-sorter:active {
  transform: scale(0.99);
}

.d-table tbody tr.d-table__second-header {
  border: 1px solid #e2e8f0;
  text-transform: uppercase;
  font-weight: bold;
  text-align: left;
  background: #f6f9fc;
  color: #8898aa;
  font-size: 11px;
  line-height: 1;
}

.d-table tbody tr.d-table__second-header:hover {
  background: #f6f9fc !important;
}

.d-table tbody tr.d-table__second-header th:first-child {
  padding: 0.5rem 2rem;
}

@media print {
  .subjects_subject {
    background: transparent !important;
    font-weight: normal !important;
    height: auto !important;
    box-shadow: none;
    color: black !important;
    padding: 0;
    margin: 2px 2px 2px 0px;
  }

  .icon-menu-open {
    display: none;
  }
}

</style>



// WEBPACK FOOTER //
// UserTasksTableSubstituteHours.vue?f88f04fe